/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraMisConfiguration {
    getFixupPrototypeFunction() { return InfraMisConfiguration.fixupPrototype; }

    static newInstance(model: Partial<InfraMisConfiguration>): InfraMisConfiguration {
        let obj = Object.assign(new InfraMisConfiguration(), model);
        InfraMisConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraMisConfiguration>): InfraMisConfiguration {
        if (!model) return null;
        return InfraMisConfiguration.newInstance(<InfraMisConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraMisConfiguration) {
        if (!obj) return;

        models.InfraMisConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraMisConfiguration): boolean {
        Object.setPrototypeOf(obj, InfraMisConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
        if (this.saving_per_day === undefined) {
            this.saving_per_day = 0;
        }
        if (this.saving_per_month === undefined) {
            this.saving_per_month = 0;
        }
        if (this.saving_per_year === undefined) {
            this.saving_per_year = 0;
        }
        if (typeof this.snapshot_date === "string") {
            this.snapshot_date = new Date(<string><any>this.snapshot_date);
        }
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
    }

    /**
     * Snapshot date of the recommendation (YYYY-MM-DD format)
     */
    snapshot_date: Date;

    /**
     * Status of the policy resource recommendation
     */
    status: models.PolicyResourceRecommendationStatus;

    /**
     * Count value (0 for deleted, 1 for active)
     */
    count: number;

    /**
     * Policy ID associated with the recommendation
     */
    policy_id: string;

    /**
     * Recommendation definition ID
     */
    recommendation_definition_id: string;

    /**
     * Timestamp when the recommendation was created
     */
    created_at: Date;

    /**
     * Cloud provider name
     */
    service_account_id: string;

    /**
     * Unique ID of the resource
     */
    resource_id: string;

    /**
     * Resource identifier
     */
    resource: string;

    /**
     * Name of the resource
     */
    resource_name: string;

    /**
     * Region of the resource
     */
    region: string;

    /**
     * Type of the resource
     */
    resource_type: string;

    /**
     * Category of the resource
     */
    resource_category: string;

    /**
     * Resource group of the resource
     */
    resource_group: string;

    /**
     * Current SKU (cost recommendations only)
     */
    current_sku: string;

    /**
     * Recommended SKU (cost recommendations only)
     */
    recommended_sku: string;

    /**
     * Currency code (cost recommendations only)
     */
    currency: models.Currency;

    /**
     * Estimated daily cost savings(cost recommendations only)
     */
    saving_per_day: number;

    /**
     * Estimated monthly cost saving(cost recommendations only)
     */
    saving_per_month: number;

    /**
     * Estimated yearly cost saving(cost recommendations only)
     */
    saving_per_year: number;

}
